export const ADD_SLICE = 'ADD_SLICE'
export const DELETE_SLICE = 'DELETE_SLICE'
export const SAVE_SLICES_FORM_DATA = 'SAVE_SLICES_FORM_DATA'
export const RESET_STATE = 'RESET_STATE'
export const SAVE_CREDITS_FORM_DATA = 'SAVE_CREDITS_FORM_DATA'
export const SAVE_ART_FORM_DATA = 'SAVE_ART_FORM_DATA'
export const SAVE_FILES_FORM_DATA = 'SAVE_FILES_FORM_DATA'
export const IS_FETCHING = 'IS_FETCHING'

export const addSliceAC = () => ({type: ADD_SLICE})
export const deleteSliceAC = (sliceNumber) => ({type: DELETE_SLICE, sliceNumber})
export const saveSlicesFormDataAC = (formData) => ({type: SAVE_SLICES_FORM_DATA, formData})
export const resetStateAC = () => ({type: RESET_STATE})
export const saveCreditsFormDataAC = (formData) => ({type: SAVE_CREDITS_FORM_DATA, formData})
export const saveArtFormDataAC = (art) => ({type: SAVE_ART_FORM_DATA, art})
export const saveFilesFormDataAC = (formData) => ({type: SAVE_FILES_FORM_DATA, formData})
export const isFetchingAC = (isFetching) => ({type: IS_FETCHING, isFetching})
